
export default function(
    parent,
    view
)
{
    //true when jackpot finished it's (when prize already displayed) animation:
    const $flowing = parent.s( "flowing", false );
    
    const $click = parent.s( "click" );
    view.onClick = () => $click.next();
    
    parent.s( "play" ).subscribe( function( state )
    {
        const jackpot = state.state.jackpot_info;
        
        $flowing.next( true );
        
        console.log( "Starting jackpot with", jackpot );
        view.show(
            jackpot.index - 1,
            jackpot.show_time,
            jackpot.win_show_start,
            jackpot.win_show_end,
            () => $flowing.next( false )
        );
    } );
    
    parent.s( "restore" ).subscribe( function( state )
    {
        const jackpot = state.state.jackpot_info;
        
        $flowing.next( true );
        
        console.log( "Restoring jackpot with", jackpot );
        view.show(
            jackpot.index - 1,
            jackpot.show_time,
            jackpot.win_show_end,
            () => $flowing.next( false )
        );
    } );
    
    parent.s( "hide" ).subscribe( () => view.hide() );
}





// WEBPACK FOOTER //
// ./src/library/jackpot.es6